import { UUID } from 'symbols';

export enum CompletedWorkTransactionTypeEnum {
  INPUT = 'input',
  OUTPUT = 'output',
}

export interface CompletedWorkTransactionModel {
  id: UUID,
  sum: number,
  price: number,
  count: number,
  createdAt: string,
  sn?: string,
  equipment: string,
  comment: string,
  userId: UUID,
  forMonth?: string,
  type: CompletedWorkTransactionTypeEnum;
  isAutoAdded?: boolean;
}

export interface CompletedWorkFilterModel {
  userId?: UUID,
  date?: string,
  searchText?: string,
}

export interface SummaryCompletedWorkModel {
  totalSum: number,
  totalIssued: number,
  totalCharged: number,
  totalBalance: string,
  firstName: string
  lastName: string
  userId: UUID;
}


export interface CompletedWorkTransactionExpectBackend {
  id?: UUID,
  sum: number,
  price?: number,
  count?: number,
  comment?: string,
  sn?: string,
  equipment?: string,
  forMonth?: string,
  type: CompletedWorkTransactionTypeEnum;
  userId: UUID;
}
